import { PARAMETERS_REFRESH_INTERVAL_SECONDS } from 'config';
import React, { useCallback, useEffect } from 'react';
import { ParameterService } from 'services/ParametersProviderApi/ParametersService';
import { SECONDS } from 'utils';
import { EParametersActionType, useDynamicParameters, useDynamicParametersDispatch } from './DynamicParametersContext';
import { isEqual } from 'lodash-es';

export const DynamicParametersRefresher: React.FC = () => {
  const { dynamicParameters } = useDynamicParameters();
  const dispatchDynamicParameters = useDynamicParametersDispatch();

  const refreshDynamicParameters = useCallback(async () => {
    const newDynamicParameters = await ParameterService.fetchParameters();
    if (dispatchDynamicParameters && !isEqual(dynamicParameters, newDynamicParameters)) {
      dispatchDynamicParameters({ 
        type: EParametersActionType.SET_PARAMETERS, 
        value: newDynamicParameters
      });
    }
  }, [dispatchDynamicParameters, dynamicParameters]);
  
  useEffect(() => {
    refreshDynamicParameters();
    const intervalId = setInterval(refreshDynamicParameters, PARAMETERS_REFRESH_INTERVAL_SECONDS * SECONDS);
    
    return () => clearInterval(intervalId);
  }, [refreshDynamicParameters]);

  return null;
}
